import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { Img } from '@shared/Frontend/components/img'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React, { ReactNode } from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'
import { getSite } from '@shared/Frontend/utils/site'

export const CTABlock: BlocksView['CTABlock'] = (props) => {
  const { displayOption, id, bgColour, image, introduction, label, title } = props
  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section
      id={id}
      ref={ref}
      className={cn(
        `block block--cta cta--${image ? 'image' : 'text'} cta--${
          displayOption == 'content-width' ? 'cw' : 'fw'
        } ls-spacing`,
        bgColour && `bg--${bgColour}`,
        inView && 'inview'
      )}
    >
      <div className="block__inner ls-container ls-gutter">
        <div className={`block__layout ${image ? 'gridsys--grid' : ''}`}>
          <div className="block__content">
            <BlockHeader title={title} label={label} />

            {introduction && <div className="block__text text--xl" dangerouslySetInnerHTML={{ __html: introduction }} />}

            <BlockActions {...props} datalayerCategory="call_to_action_block" />
          </div>

          {image && (
            <div className="block__visual">
              <div className='block__media fit-object'>
                <Img
                  {...image}
                  loading="lazy"
                  className="block__image"
                  width="576"
                  height="576"
                  sizes='576px'
                />
              </div>
            </div>
          )}

          <CTABlob {...props} />

        </div>
      </div>
    </section>
  )
}

export const CTABlob: BlocksView['CTABlock'] = ({ image }) => {
  const site = getSite()
  console.info(site)
  if (site !== 'ZEG') return null

  if (image) {
    return (
      <svg className="cta__blob" width="573" height="484" viewBox="0 0 573 484" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M96.6822 376.91C261.502 40.6602 465.134 333.07 562.943 163.704C597.702 103.535 542.851 -70.1652 390.712 -228.595C197.438 -429.868 61.3239 -444.37 -14.4271 -383.04C-178.772 -249.957 25.342 -17.6333 -131.837 46.784C-284.462 109.36 -454.277 -92.2173 -513.335 -3.18027C-555.839 60.8832 -413.566 218.721 -284.072 335.049C-167.344 439.915 -6.68683 587.796 96.6822 376.91Z" fill="#0E347A" />
      </svg>
    )
  }

  return (
    <svg className="cta__blob" width="619" height="751" viewBox="0 0 619 751" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M147.145 217.303C405.098 239.578 331.809 -0.789335 468.176 1.01005C516.627 1.64181 588.941 102.317 610.45 259.181C637.778 458.459 586.559 550.645 519.621 575.683C374.384 629.996 334.579 412.061 230.487 487.796C129.397 561.327 167.105 745.779 92.0906 749.698C38.1121 752.525 12.636 602.171 4.58482 475.664C-2.67612 361.628 -14.635 203.331 147.145 217.303Z" stroke="#F4BB91" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  )
}
